import * as Scrivito from "scrivito";
import htmlOptions from "^/utils/htmlOptions";

Scrivito.provideEditingConfig("TextImagePanelWidget", {
  title: "Text Image Panel",
  attributes: {
    headline: {
      title: "Headline",
    },
    content: {
      title: "Content",
      options: htmlOptions,
    },
    image: {
      title: "Image",
    },
    video: {
      title: "Video",
      description:
        "Provide YouTube link. If provided, video will be shown instead of the image",
    },
    destination: {
      title: "Destination",
    },
    color: {
      title: "Color",
    },
  },
  properties: [
    "headline",
    "description",
    "date",
    "content",
    "image",
    "video",
    "videoObject",
    "destination",
  ],
  initialContent: {
    headline: "Lorem Ipsum",
    description:
      "dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
  },

  validations: [
    [
      "description",
      (description, { widget }) => {
        const plainText = description.replace(/<[^>]*>/g, "").trim();
        const container = widget.container();
        const containerClass = container?.objClass();
        const isHeroSlider = containerClass === "HeroSliderWidget";
        if (isHeroSlider && plainText.length > 80) {
          return {
            message: `The description must not exceed 80 characters. You have used ${plainText.length} characters. Maximum is 80 characters.`,
            severity: "error",
          };
        }
        if (isHeroSlider && plainText.length > 50) {
          return {
            message: `The description must not exceed 50 characters. You have used ${plainText.length} characters. Maximum is 80 characters.`,
            severity: "warning",
          };
        }
        return {
          message: `You have used ${plainText.length} characters. ${
            isHeroSlider ? "Maximum is 80 characters." : ""
          }`,
          severity: "info",
        };
      },
    ],
  ],
});
